import { useGallery, useWindowEvent, AspectRatio } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import MediaContent$1 from '../MediaContent/MediaContent.js';
import Controls$1 from './subcomponents/Controls/Controls.js';
import StyledGallery from './Gallery.style.js';
import Slider$1 from './subcomponents/Slider/Slider.js';

const Gallery = ({
  size,
  images
}) => {
  const {
    index,
    handlePrev,
    handleNext,
    handleChange
  } = useGallery(images);
  useWindowEvent('keydown', ({
    key
  }) => {
    if (key === 'ArrowRight') return handleNext();
    if (key === 'ArrowLeft') return handlePrev();
  });
  return /*#__PURE__*/React$1.createElement(StyledGallery, null, /*#__PURE__*/React$1.createElement(MediaContent$1, {
    variant: size,
    hasFocalPoint: images[0].hasFocalPoint,
    focalPoint: images[0].focalPoint
  }, /*#__PURE__*/React$1.createElement(AspectRatio, {
    ratio: `${images[0].width}:${images[0].height}`
  }, /*#__PURE__*/React$1.createElement(Slider$1, {
    images: images,
    currentIndex: index,
    handleChange: handleChange
  })), /*#__PURE__*/React$1.createElement(Controls$1, {
    handleChange: handleChange,
    currentIndex: index,
    numberOfBullets: images.length,
    currentCaption: images[index] && images[index].caption
  })));
};

Gallery.propTypes = {
  size: PropTypes$1.oneOf(['m', 'l', 'xl']),
  images: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired
};
Gallery.defaultProps = {
  size: 'm'
};

export default Gallery;
